/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('click', async function (e) {
  const button = e.target.closest('.js-quick-add');
  if (!button) return;

  e.preventDefault();

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!response.ok) throw new Error('Add to cart failed');

    // ✅ This triggers Prestige’s cart drawer
    document.documentElement.dispatchEvent(
      new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: { id: Number(variantId) },
          quantity: 1
        }
      })
    );

  } catch (error) {
    console.error(error);
    window.location.href = '/cart';
  }
});

